// import * as Contacts from 'expo-contacts';
export const handleContactPermission = async () => {
  return true;
};

const updateContactsApi = async () => {
  return true;
};
